// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Forbidden_logoWrapper__OEzVs","forbiddenWrapper":"Forbidden_forbiddenWrapper__gdLMa"};